import { render, staticRenderFns } from "./BusPlanningCard.vue?vue&type=template&id=17f22106&scoped=true&"
import script from "./BusPlanningCard.vue?vue&type=script&lang=js&"
export * from "./BusPlanningCard.vue?vue&type=script&lang=js&"
import style0 from "./BusPlanningCard.vue?vue&type=style&index=0&id=17f22106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f22106",
  null
  
)

export default component.exports